import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgxSpinnerService } from "ngx-spinner";

import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/shared/common.service';
import { AppTokenHandler } from 'src/app/common/app-token-handler';
import { Global } from 'src/app/Global';
import { DataService } from 'src/app/common/data.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-startup-popup',
  templateUrl: './startup-popup.component.html',
  styleUrls: ['./startup-popup.component.css'],
  // standalone:true,
  // imports:[MatRadioModule,MatDialogModule,ReactiveFormsModule]
})
export class StartupPopupComponent implements OnInit {

  ConsentForm: UntypedFormGroup;
  constructor(private _fb: UntypedFormBuilder, private _router: Router, private spinnerService: NgxSpinnerService,
    public _commonService: CommonService, private appToken: AppTokenHandler,
    private _global: Global, private data: DataService,
    public dialogRef: MatDialogRef<StartupPopupComponent>) { }

  ngOnInit() {

    this.ConsentForm = this._fb.group({
      IsConsent: ['', [Validators.required]]
    });
  }

  updateSecurityCheck() {
    if (this.ConsentForm.valid) {
      if (this.ConsentForm.controls.IsConsent.value === 'false') {
        this.dialogRef.close();
        this._router.navigate(['/logout']);
      } else {
        this.spinnerService.show();
        this._commonService.UpdateSecurityConsent().subscribe(result => {
          if (result['IsConsent'] === true) {
            this._global.IsConsent = true;
            this.dialogRef.close();
            // this._router.navigate(['/dashboard']);
            this.Logout();
          }
        }, (error) => {
          this.spinnerService.hide();
        }, () => {
          this.spinnerService.hide();
        });
      }
    }
  }

  Logout() {
    this.data.LogoutUser('Token/logout').subscribe(data => {
    }, (error) => {
    }, () => {
      this.appToken.clearSessionToken();
      this.Login();
    });
  }

  Login() {
    this._router.navigate(['/login']);
  }

}
